export default defineNuxtPlugin(() => {
	const config = useRuntimeConfig()
	const $api = $fetch.create({
		baseURL: String(config.public.APIUrlBase),
		onResponseError(arg) {
			if (arg.response?._data?.responseText) {
				const errorMessage = arg.response?._data.responseText
				if (Array.isArray(errorMessage)) {
					for (let index = 0; index < errorMessage.length; index++) {
						useNotification().alert({
							status: arg.response.status === 1 ? 200 : arg.response.status,
							message: errorMessage[index]
						})
					}
				} else {
					useNotification().alert({
						status: arg.response.status,
						message: errorMessage
					})
				}
			}
		},
		onRequestError(arg) {
			if (arg.error) {
				if (arg.error?.message?.includes('Failed to fetch')) {
					return useNotification().alert({
						status: 400,
						message: 'Poor network connection.'
					})
				}

				useNotification().alert({
					status: 400,
					message: arg?.error?.message || 'Connection Timeout ):'
				})
			}
		},
		mode: 'cors'
	})
	// Expose to useNuxtApp().$api
	return {
		provide: {
			api: $api
		}
	}
})
